import { render, staticRenderFns } from "./msbHome.vue?vue&type=template&id=40beb931&scoped=true&"
import script from "./msbHome.vue?vue&type=script&lang=js&"
export * from "./msbHome.vue?vue&type=script&lang=js&"
import style0 from "./msbHome.vue?vue&type=style&index=0&id=40beb931&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40beb931",
  null
  
)

export default component.exports